module.exports = __webpack_public_path__ + "static/img/产品图2@2x.7a20567.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/产品图2@2x.png
// module id = viY3
// module chunks = 192